import React, { useState } from 'react';
import { Modal, ModalProps } from 'semantic-ui-react';
import Button from 'components/button';
import styles from './styles/profileImageModal.scss';
import { IFile } from 'services';
import { Popup } from 'components/quashed';

type IProps = {
  onClose(): void;
  onUpload(p: IFile): void;
};

const ProfileImageModal = ({
  onClose,
  onUpload,
  ...modalProps
}: IProps & ModalProps) => {
  const [picture, setPicture] = useState<IFile>(null);

  const handleChange = (e) => {
    const target = e.target.files[0];
    setPicture(target);
  };

  const handleClose = () => {
    setPicture(null);
    onClose();
  };

  const handleUpload = () => {
    onUpload(picture);
    onClose();
  };

  return (
    <Popup
      className={styles.modal}
      {...modalProps}
      showNav={true}
      onClose={handleClose}
    >
      <Modal.Content>
        <div className={styles.title}>Upload your photo</div>
        <div className={styles.subtitle}>
          We want your photo to look amazing, so please ensure your photo fits
          in this <b>circle</b>.
        </div>
        <div
          className={classnames(styles.imgWrap, !picture && styles.withPadding)}
        >
          {picture ? (
            <img alt="Profile pic" src={URL.createObjectURL(picture)} />
          ) : (
            <div className={styles.placeholder} />
          )}
        </div>
        {picture && (
          <Button
            className={styles.upload}
            text="Upload"
            onClick={handleUpload}
          />
        )}
        <label className={classnames(styles.browse, picture && styles.change)}>
          {picture ? 'Change' : 'Browse'}
          <input type="file" onChange={handleChange} accept="image/*" />
        </label>
      </Modal.Content>
    </Popup>
  );
};

export default ProfileImageModal;
